<template>
  <div>
    <div class="container content">
      <div class="row">
        <div class="col-md-4 col-md-offset-4">
          <img src="../assets/logo2.png" alt="Southwestern Adventist University" style="width:100%; padding: 40px;">
          <div class="alert alert-danger" v-if="error">
            <h3>Error</h3>
            <p>{{ error }}</p>
          </div>
          <h1 class="text-center" style="font-weight: 200; letter-spacing: 1px;">Welcome!</h1>
          <form action="#" method="post" @submit.prevent="submitForm" v-show="noCode">
            <input type="hidden" name="state" v-model="auth.state" />
            <input type="hidden" name="redirect_uri" v-model="auth.redirect_uri" />
            <input type="hidden" name="response_type" v-model="auth.response_type" />
            <input type="hidden" name="client_id" v-model="auth.client_id" />
            <div class="form-group">
              <input type="text" name="username" id="username" value="" class="form-control input-lg" placeholder="Username" autofocus v-model="auth.username">
            </div>
            <div class="form-group">
              <input type="password" name="password" id="password" value="" class="form-control input-lg" placeholder="Password" autocomplete="off" v-model="auth.password">
            </div>
            <button type="submit" name="submit" id="submit" class="btn btn-primary btn-lg btn-block">Sign In</button>
            <hr>
          </form>
        </div>
      </div>
    </div>
    <footer>
      <div class="container text-center">
        <div class="row">
          <div class="col-md-12">
            <p id="copyright">&copy; {{ year }} Southwestern Adventist University</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
let $ = require('jquery')
export default {
  name: 'Auth',
  data () {
    return {
      year: new Date().getFullYear(),
      error: this.$route.query.error,
      noCode: false,
      auth: {
        username: this.$route.query.username,
        password: '',
        state: this.$route.query.state,
        redirect_uri: this.$route.query.redirect_uri,
        response_type: this.$route.query.response_type,
        client_id: this.$route.query.client_id
      }
    }
  },
  created: function () {
    window.history.replaceState('login', 'Login | Southwestern Adventist University', '/oauth/authorize')
    let vue = this
    $.post('/oauth/authorize', this.auth)
      .done(function (code) {
        if (code.length === 0) {
          vue.noCode = true
          return
        }
        if (!vue.auth.state) {
          window.location = vue.auth.redirect_uri + '?code=' + code
          return
        }
        window.location = vue.auth.redirect_uri + '?state=' + vue.auth.state + '&code=' + code
      })
      .fail(function (err) {
        console.log('Could not log in with cookie: ', err)
        vue.noCode = true
      })
  },
  methods: {
    submitForm () {
      console.log('Submitting form')
      this.error = ''
      if (!this.auth.username) {
        this.error = 'Username is a required field'
        $('#submit').blur()
        return
      }

      if (!this.auth.password) {
        this.error = 'Password is a required field'
        $('#submit').blur()
        return
      }

      let vue = this
      $.post('/oauth/login', this.auth)
        .done(function (code) {
          if (!vue.auth.state) {
            window.location = vue.auth.redirect_uri + '?code=' + code
            return
          }
          window.location = vue.auth.redirect_uri + '?state=' + vue.auth.state + '&code=' + code
        })
        .fail(function (err) {
          console.error('Could not log in: ', err)
          vue.error = 'Could not log in: ' + err.responseJSON
        })
        .always(function () {
          $('#submit').blur()
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Auth.vue